module.exports = __webpack_public_path__ + "img/GL.8536e778.svg";